import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import UserMenu from "./UserMenu";
import LeftProfileCard from "./LeftProfileCard";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "../shared/const.prop";

const LeftSideBar = () => {
  const { id } = useParams();
  const [content, setContent] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [otherUser, setOtherUser] = useState("");
  const [isOtherUser, setIsOtherUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const appContext = useContext(AppContext);
  const test = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  const location = useLocation();

  const toggleSettingsHandler = () => setShowSettings((prev) => !prev);

  useEffect(() => {
    const userId = user?.userId || user?.data?.data?.userId;
    const userName = user?.userName || user?.data?.data?.userName;
    const path = location.pathname.trim().split("/")[1];
    if (
      path.trim() === "myspace" ||
      (userName && path.trim() === userName) ||
      path.trim() === "my-posts" ||
      isOtherUser
    ) {
      setContent(
        <UserMenu
          showProfile={false}
          showSettings={showSettings}
          spaceMenu={true}
          path={location.pathname}
          otherUser={otherUser}
        />
      );
    } else {
      setContent(<UserMenu showProfile={false} showSettings={showSettings} />);
    }
  }, [location.pathname, showSettings, userName, isOtherUser, otherUser]);

  // useEffect(() => {
  //   setLoading(true);
  //   let path = null;
  //   path = location.pathname.includes("user")
  //     ? location.pathname.trim().split("/")[2]
  //     : id && !location.pathname.includes("myspace")
  //     ? location.pathname.trim().split("/")[1]
  //     : null;
  //   if (path && path !== userName) {
  //     getProfile(path);
  //     setIsOtherUser(true);
  //     setLoading(false);
  //     // setOtherUser();
  //   } else {
  //     setOtherUser();
  //     setIsOtherUser(false);
  //     setLoading(false);
  //   }
  // }, [location.pathname, appContext.openModal, otherUser]);

  useEffect(() => {
    setLoading(true);
    let path = null;

    const pathnameParts = location.pathname.trim().split("/"); // Ensure it's split properly

    if (location.pathname.includes("user") && pathnameParts.length > 2) {
      path = pathnameParts[2];
    } else if (
      id &&
      !location.pathname.includes("myspace") &&
      pathnameParts.length > 1
    ) {
      path = pathnameParts[1];
    }

    if (path && path !== userName) {
      getProfile(path);
      setIsOtherUser(true);
    } else {
      setOtherUser(null);
      setIsOtherUser(false);
    }

    setLoading(false);
  }, [location.pathname, appContext.openModal, id, userName]);

  const getProfile = (id) => {
    axiosHttp
      .get("profile/" + id)
      .then((apiResponse) => {
        if (apiResponse.status === 200) {
          setOtherUser(apiResponse?.data?.data ?? {});
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: "Error, please try after sometime.",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        if (error.response.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: "Something went wrong, please try again later.",
          });
        }
        setIsOtherUser(false);
      });
  };

  // console.log("isOther", isOtherUser);
  // console.log("other", otherUser);

  return (
    <>
      <LeftProfileCard
        toggleSettingsHandler={toggleSettingsHandler}
        showSettings={showSettings}
        isOtherUser={isOtherUser}
        otherUser={otherUser}
        loading={loading}
      />
      {(isOtherUser && !otherUser?.isBlockedUser) || !isOtherUser ? (
        <div>{content}</div>
      ) : null}
    </>
  );
};

export default LeftSideBar;
